import Image from 'next/image';
import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import style from './cpCoverPhoto.module.scss';

function CpCoverPhoto({ coverList }: { coverList: { id: string; url: string }[] }) {
    return (
        <div className={style.cpCoverPhoto}>
            <Swiper
                modules={[Autoplay, Pagination]}
                autoplay={{ delay: 5000 }}
                pagination={{
                    clickable: true
                }}
                spaceBetween={8}
            >
                {coverList?.map((img, imgIdx) => (
                    <SwiperSlide key={`${img.id}_${imgIdx}`} className={style.imgBox}>
                        <Image
                            alt=""
                            src={img.url}
                            fill
                            style={{ objectFit: 'cover' }}
                            className={style.img}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
export default CpCoverPhoto;
